import angular from 'angular';
import moment from 'moment';
import { EstabelecimentosService } from '../../../Estabelecimentos/estabelecimentos.service';
import { IContribuinteIndividualGet } from '../model/contribuintesindividuais.model';
import { TipoContaPixEnum } from '../../../../shared/enums/TipoContaPixEnum';
import { TipoRecebimentoEnum } from '../../../../shared/enums/TipoRecebimentoEnum';
import {
    contaBancoValida,
    getMensagemContaBanco,
    digitoVerificadorContaValido,
    getMensagemDigitoVerificador,
    TipoPagamentoEnum
} from '../../../../utils/dados-bancarios';

export class MeurhContribuintesIndividuaisFormController {

    static $inject = [
        '$scope',
        '$rootScope',
        'EstabelecimentosService'
    ];

    public form: angular.IFormController;
    public editable = false;
    public entity: IContribuinteIndividualGet;

    public busy = false;
    public limiteDataNascimento = moment().subtract(16, 'years');
    public limiteDataMes = moment().subtract(192, 'month');
    public TipoContaPixEnum = TipoContaPixEnum;
    public TipoRecebimentoEnum = TipoRecebimentoEnum;

    public exibeAlertaConta: boolean = false;
    public focoInputConta: boolean = false;

    public exibeAlertaDigitoVerificador: boolean = false;
    public focoInputDigitoVerificador: boolean = false;

    public matriculaAutomatica: boolean = false;

    public tiposPagamentoChecaDv = [
        TipoPagamentoEnum.CONTA_CORRENTE,
        TipoPagamentoEnum.CONTA_POUPANCA,
        TipoPagamentoEnum.CONTA_SALARIO,
        TipoPagamentoEnum.PIX_AGENCIA_CONTA
    ];

    constructor(
        public $scope: angular.IScope,
        public $rootScope: angular.IRootScopeService & { session: any, configuracoes: any },
        public EstabelecimentosService: EstabelecimentosService,
    ) {}

    $onInit() {
        // this.preencheCampoEstabelecimento();

        if (this.$rootScope.configuracoes.CODIGO_FUNCIONARIO_AUTOMATICO) {
            this.matriculaAutomatica = true;
        }

        if (this.entity?.unidadesalariofixo !== null && this.entity?.unidadesalariofixo !== undefined) {
            this.entity.unidadesalariofixo = this.entity.unidadesalariofixo.toString();
        }
    }

    /*
    preencheCampoEstabelecimento() {
        const estabelecimento = !this.entity.estabelecimento ?
            this.$rootScope.session.entities.estabelecimento.estabelecimento :
            this.entity.estabelecimento.estabelecimento;
        this.busy = true;
        this.EstabelecimentosService.get(estabelecimento)
            .then((response: IContribuinteIndividualGet['estabelecimento']) => {
                this.entity.estabelecimento = response;
            }).catch((e: any) => {
                console.error(e);
            }).finally(() => {
                this.busy = false;
            });
    } */

    preencheCamposRecebimento() {
        if (
            !(this.entity.tiporecebimento === TipoRecebimentoEnum.CONTA_CORRENTE ||
            this.entity.tiporecebimento === TipoRecebimentoEnum.CONTA_POUPANCA ||
            this.entity.tiporecebimento === TipoRecebimentoEnum.CONTA_SALARIO ||
            this.entity.tiporecebimento === TipoRecebimentoEnum.PIX_AGENCIA_CONTA)
        ) {
            this.resetDadosBancarios();
        }

        if (this.entity.tiporecebimento !== null) {
            this.entity.semdadosbancarios = false;
        }

        if (this.entity.tiporecebimento !== TipoRecebimentoEnum.PIX_AGENCIA_CONTA) {
            this.entity.tipocontapix = null;
        }

        if (this.entity.tiporecebimento === TipoRecebimentoEnum.PIX_CPF) {
            this.entity.chavepix = this.entity.cpf;
        } else {
            this.entity.chavepix = null;
        }
    }

    resetDadosBancarios() {
        this.entity.banco = null;
        this.entity.agencia = null;
        this.entity.agencianumero = null;
        this.entity.numeroconta = null;
        this.entity.numerocontadv = null;
        this.entity.agencianumerodv = null;
    }

    setChavePix() {
        if (this.entity.tiporecebimento === TipoRecebimentoEnum.PIX_CPF) {
            this.entity.chavepix = this.entity.cpf;
        }
    }

    desabilitarNenhumaInstituicaoBancaria() {
        return !!this.$rootScope.configuracoes.DESABILITAR_NENHUMA_INSTITUICAO_BANCARIA_ADMISSOES;
    }

    public limpaDadosAgenciaConta() {
        this.entity.agencianumero = null;
        this.entity.agencianumerodv = null;
        this.entity.numeroconta = null;
        this.entity.numerocontadv = null;
    }

    public limpaBanco() {
        this.entity.banco = null;
    }

    public validaContaPagamento() {
        if (!this.entity.banco || !this.entity.tiporecebimento || !this.entity.numeroconta) {
            this.exibeAlertaConta = false;
            return;
        }

        this.exibeAlertaConta = !contaBancoValida(this.entity.banco, this.entity.tiporecebimento.toString(), this.entity.numeroconta, this.entity.tipocontapix?.toString()) &&
            !this.form.numeroconta?.$error?.required && this.editable;
    }

    public verificaExibicaoAlertaConta() {
        if (!this.entity.banco || !this.entity.tiporecebimento || !this.entity.numeroconta) {
            return false;
        }

        return !this.focoInputConta && this.exibeAlertaConta;
    }

    public getMensagemAlertaConta(): string {
        return getMensagemContaBanco(this.entity.banco, this.entity.tiporecebimento!.toString(), this.entity.numeroconta!, this.entity.tipocontapix?.toString());
    }

    public validaDigitoVerificadorConta() {
        if (!this.entity.banco || !this.entity.tiporecebimento || !this.entity.numerocontadv) {
            this.exibeAlertaDigitoVerificador = false;
            return;
        }

        this.exibeAlertaDigitoVerificador = !digitoVerificadorContaValido(this.entity.banco, this.entity.tiporecebimento.toString(), this.entity.numerocontadv, this.entity.tipocontapix?.toString()) &&
            !this.form.numerocontadv?.$error?.required && this.editable;
    }

    public verificaExibicaoAlertaDigitoVerificador() {
        if (!this.entity.banco || !this.entity.tiporecebimento || !this.entity.numerocontadv) {
            return false;
        }

        return !this.focoInputDigitoVerificador && this.exibeAlertaDigitoVerificador;
    }

    public getMensagemAlertaDigitoVerificador(): string {
        return getMensagemDigitoVerificador(this.entity.banco, this.entity.tiporecebimento!.toString(), this.entity.numerocontadv!, this.entity.tipocontapix?.toString());
    }

}
